<template>
    <b-card header-classes="bg_transparent" class="people-feeling-unwell">
        <b-row slot="header">
            <b-col cols="12" class="px-0">
                <h5 class="h5 mb-0">{{ $t('dashboard.peopleFeelingUnwell') }}</h5>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12">
                <div class="people-feeling-unwell-chart" ref="peoplefeelingunwellchart"></div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import am4themes_material from "@amcharts/amcharts4/themes/material"
import { mapState } from 'vuex'

am4core.useTheme(am4themes_material)

    export default {
        data() {
            return {
                chart: null
            }
        },
        methods: {
            loadChart() {
                this.chart = am4core.create(this.$refs.peoplefeelingunwellchart, am4charts.PieChart);

                this.chart.data = this.PeopleFeelingUnwell_data.Stats

                let pieSeries = this.chart.series.push(new am4charts.PieSeries())
                pieSeries.dataFields.value = 'people'
                pieSeries.dataFields.category = 'date'
                pieSeries.labels.template.disabled = false;
                
                pieSeries.ticks.template.disabled = true;
                pieSeries.alignLabels = false;
                pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
                pieSeries.labels.template.radius = am4core.percent(-40);
                pieSeries.labels.template.fill = am4core.color("white");

                pieSeries.labels.template.adapter.add("radius", function(radius, target) {
                    if (target.dataItem && (target.dataItem.values.value.percent < 10)) {
                        return 0;
                    }
                    return radius;
                });
                
                pieSeries.labels.template.adapter.add("fill", function(color, target) {
                    if (target.dataItem && (target.dataItem.values.value.percent < 10)) {
                        return am4core.color("#000");
                    }
                    return color;
                });

                pieSeries.slices.template.stroke = am4core.color("#fff");
                pieSeries.slices.template.strokeWidth = 2;

                pieSeries.slices.template
                    // change the cursor on hover to make it apparent the object can be interacted with
                    .cursorOverStyle = [
                        {
                            "property": "cursor",
                            "value": "pointer"
                        }
                    ];
                
                let colorSet = new am4core.ColorSet();

               // let self = this

                pieSeries.colors = colorSet
            }
        },
        mounted() {
            this.loadChart()
        },
        computed: {
            ...mapState(['PeopleFeelingUnwell_data']),            
        },
        watch: {
        }
    }
</script>

<style>
.people-feeling-unwell .card-body {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 0;
}

.people-feeling-unwell-chart {
    height: 300px;
}
</style>